import React from 'react';

const Step2PropertyDetails = ({ formData, onChange, errors }) => {
    return (
        <div className="space-y-6">
            <div>
                <h3 className="text-lg font-semibold text-soil-900 mb-4">Property Details</h3>
                <p className="text-sm text-soil-600 mb-6">
                    Provide detailed specifications about your property
                </p>
            </div>

            {/* Bedrooms, Bathrooms, Units Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                    <label className="block text-sm font-medium text-soil-600 mb-2">
                        Bedrooms
                    </label>
                    <input
                        type="number"
                        min="0"
                        value={formData.bedrooms || ''}
                        onChange={(e) => onChange('bedrooms', e.target.value ? parseInt(e.target.value) : null)}
                        className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-highland-500 ${
                            errors.bedrooms ? 'border-murram-500' : 'border-soil-100'
                        }`}
                        placeholder="2"
                    />
                    {errors.bedrooms && (
                        <p className="mt-1 text-sm text-murram-600">{errors.bedrooms}</p>
                    )}
                </div>

                <div>
                    <label className="block text-sm font-medium text-soil-600 mb-2">
                        Bathrooms
                    </label>
                    <input
                        type="number"
                        min="0"
                        value={formData.bathrooms || ''}
                        onChange={(e) => onChange('bathrooms', e.target.value ? parseInt(e.target.value) : null)}
                        className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-highland-500 ${
                            errors.bathrooms ? 'border-murram-500' : 'border-soil-100'
                        }`}
                        placeholder="2"
                    />
                    {errors.bathrooms && (
                        <p className="mt-1 text-sm text-murram-600">{errors.bathrooms}</p>
                    )}
                </div>

                <div>
                    <label className="block text-sm font-medium text-soil-600 mb-2">
                        Total Units
                    </label>
                    <input
                        type="number"
                        min="1"
                        value={formData.totalUnits || ''}
                        onChange={(e) => onChange('totalUnits', e.target.value ? parseInt(e.target.value) : 1)}
                        className="w-full px-4 py-2 border border-soil-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-highland-500"
                        placeholder="1"
                    />
                </div>
            </div>

            {/* Square Feet & Year Built */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-medium text-soil-600 mb-2">
                        Square Feet
                    </label>
                    <input
                        type="number"
                        min="0"
                        step="0.01"
                        value={formData.squareFeet || ''}
                        onChange={(e) => onChange('squareFeet', e.target.value ? parseFloat(e.target.value) : null)}
                        className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-highland-500 ${
                            errors.squareFeet ? 'border-murram-500' : 'border-soil-100'
                        }`}
                        placeholder="1200"
                    />
                    {errors.squareFeet && (
                        <p className="mt-1 text-sm text-murram-600">{errors.squareFeet}</p>
                    )}
                </div>

                <div>
                    <label className="block text-sm font-medium text-soil-600 mb-2">
                        Year Built
                    </label>
                    <input
                        type="number"
                        min="1800"
                        max={new Date().getFullYear()}
                        value={formData.yearBuilt || ''}
                        onChange={(e) => onChange('yearBuilt', e.target.value ? parseInt(e.target.value) : null)}
                        className="w-full px-4 py-2 border border-soil-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-highland-500"
                        placeholder="2020"
                    />
                </div>
            </div>

            {/* Available Units */}
            <div>
                <label className="block text-sm font-medium text-soil-600 mb-2">
                    Available Units
                </label>
                <input
                    type="number"
                    min="0"
                    value={formData.availableUnits || ''}
                    onChange={(e) => onChange('availableUnits', e.target.value ? parseInt(e.target.value) : null)}
                    className="w-full px-4 py-2 border border-soil-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-highland-500"
                    placeholder="1"
                />
                <p className="mt-1 text-xs text-soil-400">
                    Number of units currently available for rent
                </p>
            </div>

            {/* Property Description */}
            <div>
                <label className="block text-sm font-medium text-soil-600 mb-2">
                    Property Description
                </label>
                <textarea
                    value={formData.propertyDescription || ''}
                    onChange={(e) => onChange('propertyDescription', e.target.value)}
                    rows="6"
                    className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-highland-500 ${
                        errors.propertyDescription ? 'border-murram-500' : 'border-soil-100'
                    }`}
                    placeholder="Describe your property in detail. Include unique features, nearby amenities, transportation access, and what makes it special..."
                />
                {errors.propertyDescription && (
                    <p className="mt-1 text-sm text-murram-600">{errors.propertyDescription}</p>
                )}
                <p className="mt-1 text-xs text-soil-400">
                    {formData.propertyDescription?.length || 0} characters (minimum 20 recommended)
                </p>
            </div>

            <div className="bg-highland-50 border border-highland-100 rounded-lg p-4">
                <p className="text-sm text-highland-600">
                    <strong>Tip:</strong> A detailed description helps potential tenants understand your property better and increases inquiries.
                </p>
            </div>
        </div>
    );
};

export default Step2PropertyDetails;
